module.exports = __webpack_public_path__ + "static/media/amarant-mobile-screens.6b7f8897.png";